import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IndexComponent } from './index/index.component';

import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { YakkanComponent } from './yakkan/yakkan.component';
import { HeaderComponent } from './shared/component/header/header.component';
import { FooterComponent } from './shared/component/footer/footer.component';
import { SidebarComponent } from './shared/component/sidebar/sidebar.component';
import { AppliListMainComponent } from './appli-list-main/appli-list-main.component';
import { AppliSideBarComponent } from './shared/component/appli-side-bar/appli-side-bar.component';
import { AppliMainComponent } from './shared/component/appli-main/appli-main.component';
import { StayInfoComponent } from './stay-info/stay-info.component';
import { HotelInfoComponent } from './hotel-info/hotel-info.component';
import { BreakfastComponent } from './breakfast/breakfast.component';
import { StreamingComponent } from './streaming/streaming.component';
import { InfoComponent } from './info/info.component';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QRCodeModule } from 'angularx-qrcode';

const dbConfig: DBConfig = {
  name: 'OKR-DB',
  version: 1,
  objectStoresMeta: [
    {
      store: 'movie',
      storeConfig: { keyPath: 'id', autoIncrement: false },
      storeSchema: [
        { name: 'name', keypath: 'name', options: { unique: false } },
        { name: 'data', keypath: 'data', options: { unique: false } }
      ]
    }
  ]
};
@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    YakkanComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    AppliListMainComponent,
    AppliSideBarComponent,
    AppliMainComponent,
    StayInfoComponent,
    HotelInfoComponent,
    BreakfastComponent,
    StreamingComponent,
    InfoComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    QRCodeModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    BrowserAnimationsModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {}
